(() => {
  const desktopQuery = window.matchMedia('(min-width: 1024px)');
  const exactIcons = {
    addToCart: `<svg class="senlan-add-to-cart-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2.2l1.7 9.1a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 1.9-1.4L21 7H7"/><circle cx="10" cy="19" r="1.4"/><circle cx="18" cy="19" r="1.4"/></svg>`,
  };

  const ensureAddToCartIcon = (root) => {
    const addToCart = root.querySelector('#AddToCart');
    const label = addToCart?.querySelector('.single-add-to-cart-button--text');
    if (!addToCart || !label || addToCart.disabled || addToCart.classList.contains('sold-out') || label.querySelector('.senlan-add-to-cart-icon')) return;

    const icon = document.createElement('span');
    icon.className = 'senlan-add-to-cart-icon-wrap';
    icon.innerHTML = exactIcons.addToCart;
    label.prepend(icon);
  };

  const mount = (root) => {
    if (!root || root.dataset.senlanDesktopProductV2Mounted === 'true') return;

    const slider = root.querySelector('#Product-Slider');
    const thumbnails = [...root.querySelectorAll('.product-thumbnail-container .product-thumbnail')];
    const inventoryNotice = root.querySelector('inventory-notice.product-inventory-notice--wrapper');
    const variantLabel = root.querySelector('variant-selects .product-form__input--block > .form__label');
    const variantLabelCopy = document.createElement('span');
    variantLabelCopy.className = 'senlan-desktop-v2__variant-label-copy';
    root.dataset.senlanDesktopProductV2Mounted = 'true';
    ensureAddToCartIcon(root);

    const inventoryMarker = inventoryNotice ? document.createComment('senlan-desktop-v2-inventory') : null;
    inventoryNotice?.before(inventoryMarker);

    const sync = () => {
      if (desktopQuery.matches) {
        if (inventoryNotice && variantLabel) {
          variantLabel.classList.add('senlan-desktop-v2__variant-label');
          if (!variantLabelCopy.isConnected) {
            [...variantLabel.childNodes]
              .filter((node) => node !== inventoryNotice)
              .forEach((node) => variantLabelCopy.append(node));
            variantLabel.prepend(variantLabelCopy);
          }
          variantLabel.append(inventoryNotice);
        }
        return;
      }

      if (variantLabelCopy.isConnected && variantLabel) {
        while (variantLabelCopy.firstChild) variantLabel.append(variantLabelCopy.firstChild);
        variantLabelCopy.remove();
      }
      inventoryMarker?.after(inventoryNotice);
      variantLabel?.classList.remove('senlan-desktop-v2__variant-label');
    };

    const syncThumbnailSelection = () => {
      const selectedIndex = slider?.flkty?.selectedIndex;
      if (!Number.isInteger(selectedIndex)) return;
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.classList.toggle('senlan-desktop-v2-thumbnail-selected', index === selectedIndex);
      });
    };

    desktopQuery.addEventListener('change', sync);
    slider?.flkty?.on('select', syncThumbnailSelection);
    sync();
    syncThumbnailSelection();
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('.thb-product-detail.senlan-desktop-product-v2').forEach(mount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
})();
